import './sentry.js'
import './bootstrap';
import './utils/index.js';
import "./components";
import "./directives";
import "./magics";
import './hash-scroll';
import sort from '@alpinejs/sort';

Alpine.plugin(sort);
